import { forwardRef, InputHTMLAttributes } from 'react';

interface LabeledToggleProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  leftLabel?: string;
  rightLabel?: string;
}

const LabeledToggle = forwardRef<HTMLInputElement, LabeledToggleProps>(
  ({ label, leftLabel, rightLabel, ...props }, ref) => {
    return (
      <fieldset className="form-control w-full">
        {label && (
          <legend className="label">
            <span className="fieldset-legend text-primary font-normal text-sm">
              {label}
            </span>
          </legend>
        )}
        {leftLabel && (
          <span className="text-primary font-normal text-sm pr-2">
            {leftLabel}
          </span>
        )}
        <input
          ref={ref}
          type="checkbox"
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
          className="toggle border-[#374151] bg-white checked:border-[#374151] checked:bg-white"
        />
        {rightLabel && (
          <span className="text-primary font-normal text-sm pl-2">
            {rightLabel}
          </span>
        )}
      </fieldset>
    );
  }
);

LabeledToggle.displayName = 'LabeledToggle';

export default LabeledToggle;
